import camelCase from 'to-camel-case';
var namespacer = '/';
export default (function (type) {
  return type.includes(namespacer) ? type.split(namespacer).map(camelCase).join(namespacer) : camelCase(type);
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/camelCase.js
// module id = 859
// module chunks = 0